/**
 * @Author: Jon Lucas
 * @Date:   2017-09-11T14:41:41+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T14:53:23+02:00
 */

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { RouteReuseStrategy } from "@angular/router";

import { NgModule, Injector } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";

// Main header
import { MainHeaderComponent } from "./main-header/main-header.component";

// Main Left Column
import { MainLeftColumnComponent } from "./main-left-column/main-left-column.component";
import { MainNavigationComponent } from "./main-left-column/main-navigation/main-navigation.component";
import { SubNavigationComponent } from "./main-left-column/sub-navigation/sub-navigation.component";
import { SubNavigationContainerComponent } from "./main-left-column/sub-navigation-container/sub-navigation-container.component";

// Mainview
import { MainViewComponent } from "./main-view/main-view.component";
import { BuildingCustomizationComponent } from "./main-view/building-customization/building-customization.component";
import { ThreedViewComponent } from "./main-view/building-customization/threed-view/threed-view.component";
import { RoofDimensionsComponent } from "./main-view/roof-dimensions/roof-dimensions.component";
import { SurelevationDimensionsComponent } from "./main-view/surelevation-dimensions/surelevation-dimensions.component";
import { ContactFormComponent } from "./main-view/contact-form/contact-form.component";
import { EndOfStudyComponent } from "./main-view/end-of-study/end-of-study.component";
import { BelrivDimensionsComponent } from "./main-view/belriv-dimensions/belriv-dimensions.component";
import { CheckButtonListComponent } from "./main-view/check-button-list/check-button-list.component";
import { HelpDrawerComponent } from "./help-drawer/help-drawer.component";
import { AuthenticationComponent } from "./authentication/authentication.component";
import { FullScreenComponent } from "./full-screen/full-screen.component";

// UI
import { RoundButtonComponent } from "./ui/round-button/round-button.component";
import { RectangleButtonComponent } from "./ui/rectangle-button/rectangle-button.component";
import { ButtonListComponent } from "./ui/button-list/button-list.component";

// Services
import { ServiceLocator } from "./service-locator";
import { AppService } from "./app.service";
import { ConfDataService } from "./conf-data.service";

// Custom Router strategy
import { CustomReuseStrategy } from "./custom-reuse-strategy";

// Ng2 Autocomplete
import { Ng2CompleterModule } from "ng2-completer";

// Imports for loading & configuring the in-memory web api
import { InMemoryWebApiModule } from "angular-in-memory-web-api";
import { AppLoadingStateService } from "./app-loading-state.service";
import { ApiUtils } from "./util/ApiUtils";
import { AuthUtils } from "./util/AuthUtils";
import { AccessoriesComponent } from "./main-view/accessories/accessories.component";


@NgModule({
    declarations: [
        AppComponent,
        MainLeftColumnComponent,
        MainNavigationComponent,
        SubNavigationComponent,
        SubNavigationContainerComponent,
        MainHeaderComponent,
        MainViewComponent,
        BuildingCustomizationComponent,
        ThreedViewComponent,
        RoofDimensionsComponent,
        ContactFormComponent,
        EndOfStudyComponent,
        RoundButtonComponent,
        RectangleButtonComponent,
        ButtonListComponent,
        SurelevationDimensionsComponent,
        BelrivDimensionsComponent,
        CheckButtonListComponent,
        AccessoriesComponent,
        HelpDrawerComponent,
        AuthenticationComponent,
        FullScreenComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        Ng2CompleterModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
    ],
    providers: [AppService, ConfDataService, ApiUtils, AuthUtils, AppLoadingStateService, { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
    bootstrap: [AppComponent]
})
export class AppModule {

    /**
     * https://stackoverflow.com/questions/33970645/how-to-extend-a-component-with-dependency-injection-in-angular-2
     *
     * @param  {Injector} privateinjector [description]
     */
    constructor(private injector: Injector) {
        ServiceLocator.injector = this.injector;
    }

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts